import "./CheckBoxGroupFilter.css";
import { useState, useEffect } from "react";

const CheckBoxGroupFilter = ({ data, originalData, onChange, wrapFlex }) => {
  const [changed, setChanged] = useState(false);
  const [localData, setLocalData] = useState(originalData ? originalData : data);

  const handleChange = (itemSeleccionado) => {
    setLocalData((prevData) => prevData.map((item) =>
      item.id === itemSeleccionado.id
        ? { ...item, checked: !item.checked }
        : item
    ));

    setChanged(true);
  };

  useEffect(() => {
    if (changed) {
      onChange(localData);
      setChanged(false);
    }
  }, [changed]);

  useEffect(() => {
    setLocalData(originalData ? originalData : data);
  }, [originalData, data]);

  return (
    <div
      className={
        wrapFlex
          ? "wrap-checkBoxGroupFilter-container"
          : "ptur-checkBoxGroupFilter-container"
      }
      id={Math.random()}
    >
      {localData?.map((item, index) => {
        return (
          <label
            className={`checkbox-container`}
            style={{ width: wrapFlex ? "25vh" : "fit-content" }}
            key={index}
          >
            <input
              type="checkbox"
              checked={item.checked}
              onChange={() => handleChange(item)}
              className="hidden-checkbox"
            />
            <div className="custom-checkbox">
              <svg
                width="20"
                height="20"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M6 12L10 16L18 8" /* Define el trazo del tilde */
                  className="checkbox-path"
                />
              </svg>
            </div>
            <span className="rb14l">{item.descripcion}</span>
          </label>
        );
      })}
    </div>
  );
};

export default CheckBoxGroupFilter;
